module.exports = __webpack_public_path__ + "components/country-flag/static/ba-b4b1089368f91b97c89e13f2d13c1d49.svg";